import * as React from 'react';
import {
  AxisLeft as StyledAxisLeft,
  AxisLeftProps as StyledAxisLeftProps,
} from '../primitives/AxisLeft';
import { useChart } from '../providers/chart-data-provider';

export type AxisLeftProps = Omit<StyledAxisLeftProps, 'left' | 'scale'> & {
  onWidthChange?: (width: number) => void;
};

/**
 * Applies apply chart context values to the AxisLeft primitive.
 */
export function AxisLeft({ onWidthChange, ...props }: AxisLeftProps) {
  const { yScale } = useChart();
  const leftAxisRef = React.useRef<SVGTextElement>(null);
  const [currentWidth, setCurrentWidth] = React.useState<number>();

  React.useLayoutEffect(() => {
    if (leftAxisRef.current?.getBBox && onWidthChange) {
      const { width } = leftAxisRef.current.getBBox();
      if (currentWidth !== width) {
        setCurrentWidth(width);
        onWidthChange(width);
      }
    }
  }, [currentWidth, onWidthChange]);

  return (
    <StyledAxisLeft
      innerRef={leftAxisRef}
      scale={yScale}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
